export function getDateOneYearAgo(from = new Date()): Date {
	const year = from.getFullYear() - 1
	from.setFullYear(year)
	return from
}

export const toYYYYMMDD = (date = new Date()): string => {
	return `${date.getFullYear().toLocaleString('en-US', {
		minimumIntegerDigits: 4,
		useGrouping: false,
	})}-${(date.getMonth() + 1).toLocaleString('en-US', {
		minimumIntegerDigits: 2,
		useGrouping: false,
	})}-${date.getDate().toLocaleString('en-US', {
		minimumIntegerDigits: 2,
		useGrouping: false,
	})}`
}

/**
 * Compares two dates
 * @param a - First date
 * @param b - Second date
 * @returns true if a is greater than b
 */
export const compareDates = (a: Date, b: Date): boolean =>
	a.getTime() > b.getTime()

export const convertDateToLocale = (date: string, locale = 'en-US'): string => {
	// Parse the date in local timezone
	const newDate = new Date(`${date}T00:00:00`)
	return newDate.toLocaleDateString(locale, {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	})
}

export const convertDateToLocaleDatePicker = (date: string | Date): string => {
	if (!date) return ''

	// We provide a date/time string so the date is parsed to the local timezone by JS

	const newDate = date instanceof Date ? date : new Date(`${date}T00:00:00`)

	const month: string = `0${newDate.getMonth() + 1}`.slice(-2)
	const day: string = `0${newDate.getDate()}`.slice(-2)
	const year: number = newDate.getFullYear()

	return [year, month, day].join('-')
}

export function getUTCTime(): string {
	const now = new Date()
	const UTCTimeObject = new Date(
		Date.UTC(
			now.getUTCFullYear(),
			now.getUTCMonth(),
			now.getUTCDate(),
			now.getUTCHours(),
			now.getUTCMinutes(),
			now.getUTCSeconds(),
			now.getUTCMilliseconds()
		)
	)
	return UTCTimeObject.toUTCString()
}
